// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".eopoi-app-detail-social .attachDiv.socialDiv{position:static;width:auto;display:inline-block}.eopoi-app-detail-social .v-menu__content.theme--light.menuable__content__active{width:200px}", ""]);
// Exports
module.exports = exports;
